module.exports = new __parcel__URL__("bossfight_notification_letsgo_button.fc644461.png").toString();